export default "__VITE_ASSET___0QszfZ1__"